// import React from 'react'
// import MostRepeatedUserQueries from '../../../../components/ClientDashboard/analytics-components/ConversationAnalysis/MostRepeatedUserQueries';
// import DropoffKeywordInsights from '../../../../components/ClientDashboard/analytics-components/ConversationAnalysis/DropoffKeywordInsights';
// import UserAcquisitionRetentionTrends from '../../../../components/ClientDashboard/analytics-components/ConversationAnalysis/UserAcquisitionRetentionTrends';

// const ConversationAnalysisAnalytics = () => {
//   return (
//     <div>
//         <DropoffKeywordInsights/>
//         <MostRepeatedUserQueries/>   
//         <UserAcquisitionRetentionTrends/>
//     </div>
//   )
// }

// export default ConversationAnalysisAnalytics;

import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import AnalyticsCard from "../../../../components/ClientDashboard/analytics-components/Shared/AnalyticsCard";
import ConversationAnalysisAnalyticsIndex from "./ConversationAnalysisAnalytics/ConversationAnalysisAnalyticsIndex";

const ConversationAnalysisAnalytics = () => {
  const { dateFilterValue } = useOutletContext();

  return (
    <>
      <div>
        {/* 🔹 Cards Section */}
        <div>
          <ConversationAnalysisAnalyticsIndex dateFilterValue={dateFilterValue} />
        </div>
      </div>
    </>
  );
};

export default ConversationAnalysisAnalytics;
 